import { uploadUrl } from './postImages'

export const packCommentMedia = (kind, value) => {
  if (!kind || !value) return ''
  return `${kind}:${value}`
}

export const parseCommentMedia = (comment) => {
  const raw = comment?.media || ''
  const content = String(comment?.content || '').trim()
  const source = raw || (/^https?:\/\//i.test(content) && /(giphy|\.gif(\?|$))/i.test(content) ? `gif:${content}` : '')
  if (!source) return null
  const split = source.indexOf(':')
  if (split < 1) return null
  const kind = source.slice(0, split)
  const value = source.slice(split + 1)
  if (!value) return null
  if (kind === 'gif') return { kind, src: value }
  if (kind === 'photo' || kind === 'video') return { kind, src: uploadUrl(value) }
  return null
}
